import FormService from "../../services/FormService";
import FormInput from '../../components/FormInput';
import Pagination from "../../components/Pagination";

export default {
    components: {
        FormInput,
        Pagination
    },
    data() {
        return {
            isLoading: true,
            form: new FormService({
                name: null,
                inn: null, //alx
                vat_percent: null, //alx
                class_code: null, //alx
                package_code: null, //alx
                ipay_vendor_id: null, //alx
                bank_name: null,
                mfo: null,
                bank_account: null,
                phone: null,
                percent: null,
                baggage_percent: null,
            }),
            modelList: [],
            status: 0,
            links: {},
            page: 1
        }
    },
    methods: {
        Create() {
            this.form.post('transporters.create')
                .then(res => {
                    if (!res.errors) {
                        $('#exampleModal').modal('hide');
                        this.GetAll();
                        this.$store.commit('successNotify')();
                    }
                });
        },
        Read(id) {
            this.$api.get('transporters.show', id)
                .then(res => {
                    // console.log(res);
                    this.form.setData(res.data);
                    $('#exampleModal').modal('show');
                });
        },
        Update() {
            this.form.put('transporters.update', this.form.id)
                .then(res => {
                    if (!res.errors) {
                        $('#exampleModal').modal('hide');
                        this.GetAll();
                        this.$store.commit('successNotify')();
                    }
                });
        },
        Delete(id) {
            if (confirm('You are about to delete the record! \nAre you sure?')) {
                this.$api.delete('transporters.delete', id)
                    .then(res => {
                        if (!res.errors) {
                            this.GetAll();
                            this.$store.commit('successNotify')();
                        }
                    });
            }
        },
        GetAll() {
            this.$api.get('transporters.whole', {page: this.page})
                .then(res => {
                    this.modelList = res.data;
                    this.links = res.links;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },
    mounted() {
        this.GetAll();
        $('#exampleModal').on('hidden.bs.modal', (e) => {
            this.form.reset();
        })
    },
    beforeRouteUpdate(to, from, next) {
        let page = to.params.page;
        if (page) {
            this.page = page;
            this.GetAll();
        }
        next();
    }
}
